import {FormikHelpers} from 'formik';

export const onChange = (data: any, form: FormikHelpers<any>, name: string) => {
  form.setFieldValue(name, data.value);
};
